import React from 'react';
import EnrollmentData from './EnrollmentData';
import UsageData from './UsageData';
import MonetizationData from './MonetizationData';

function DashboardTabs({
    activeTab,
    dashboardData,
    loading,
    userAdoptionMetrics,
    engagementSummaryMetrics,
    userSummary,
    transactionSummary,
    funnel,
    cohort,
    sessions,
    onUserAdoptionFrequencyChange,
    onEngagementSummaryFrequencyChange,
    onUserSummaryTableChange,
    onTransactionSummaryTableChange,
}) {
    switch (activeTab) {
        case '2':
            return (
                <UsageData
                    data={dashboardData}
                    loading={loading}
                    engagementSummaryMetrics={engagementSummaryMetrics}
                    transactionSummary={transactionSummary}
                    cohort={cohort}
                    sessions={sessions}
                    onEngagementSummaryFrequencyChange={onEngagementSummaryFrequencyChange}
                    onTransactionSummaryTableChange={onTransactionSummaryTableChange}
                />
            );
        case '3':
            return <MonetizationData data={dashboardData} loading={loading} />;
        case '1':
        default:
            return (
                <EnrollmentData
                    data={dashboardData}
                    loading={loading}
                    userAdoptionMetrics={userAdoptionMetrics}
                    userSummary={userSummary}
                    funnel={funnel}
                    cohort={cohort}
                    onUserAdoptionFrequencyChange={onUserAdoptionFrequencyChange}
                    onUserSummaryTableChange={onUserSummaryTableChange}
                />
            );
    }
}

export default DashboardTabs;
